import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const FORGOT_PASSWORD_MAX_WIDTH = '376px';

const useStyles = makeStyles(({ breakpoints, spacing, palette }: Theme) => ({
  form: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    [breakpoints.up('md')]: {
      marginTop: '-100px', // To discount logo container
    },
  },

  title: {
    fontWeight: 'bold',
    color: palette.primary.main,
  },

  logoutCard: {
    width: '26%',
    [breakpoints.down('md')]: {
      width: '90%',
    },
    gap: spacing(2),
    maxWidth: FORGOT_PASSWORD_MAX_WIDTH,
    background: `${palette.neutral[500]} !important`,
  },

  login: {
    marginTop: spacing(2),
    display: 'flex',
    justifyContent: 'flex-end',
    '& a': {
      color: palette.neutral[100],
      textDecoration: 'underline',
    },
  },
}));

export default useStyles;
